import React from 'react';
import { useTranslation } from 'react-i18next';
import DeviationLink from '../../../../Duperbrowse/DeviationLink';
import { DeviationTypes } from '../../../../types/deviation';
import { getDeviationType } from '../../../_helpers';
import { getTranslationKeyForAccessibleDeviationLink } from '../../helpers';
import s from './ThumbLink.scss';
var ThumbLink = function (_a) {
    var deviation = _a.deviation, width = _a.width, height = _a.height, children = _a.children, wrapperClassName = _a.wrapperClassName;
    var t = useTranslation().t;
    var a11yLabel = getTranslationKeyForAccessibleDeviationLink(t, deviation);
    var linkAsWrapper = getDeviationType(deviation) === DeviationTypes.IMAGE;
    if (linkAsWrapper) {
        return (React.createElement(DeviationLink, { "aria-label": a11yLabel, deviation: deviation, className: wrapperClassName, style: { width: width, height: height } }, children));
    }
    return (React.createElement("div", { style: { width: width, height: height }, className: wrapperClassName },
        children,
        React.createElement(DeviationLink, { deviation: deviation, className: s['link-overlay'], title: deviation.title, "aria-label": a11yLabel },
            React.createElement("span", null))));
};
ThumbLink.displayName = 'ThumbLink';
export default ThumbLink;
//# sourceMappingURL=ThumbLink.js.map